import PropTypes from 'prop-types'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import {Col, Row} from "react-bootstrap";
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import RyzykaKatARepeater from "../parts/RyzykaKatARepeater.jsx";
import RyzykaKatBRepeater from "../parts/RyzykaKatBRepeater.jsx";

export const Ryzyka = (props) => {
    const form = props.wiz?.form || {};
    const kategoria = form.kategoria || '';

    return (
        <div>
            <JsonViewer src={props.wiz?.form || {}} show={false}/>

            <HeaderTitle noHr size={'fs-3'} title={'Ryzyka projektowe'}/>
            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź informacje o ryzykach projektowych'}
            />

            <div className={'d-flex flex-column gap-3'}>

                {kategoria === 'A' && (
                    <>
                        <label className={"d-flex fw-bold mb-0"}>M.1 Analiza ryzyka</label>

                        <RyzykaKatARepeater wiz={props.wiz} parentListName={'ryzyka_list'}/>
                        <Row>
                            <Col md={6}>
                                <InputWiz
                                    wiz={props.wiz}
                                    keyName={'osoba_monitorujaca'}
                                    value={'Kierownik projektu - Sprawdź sekcje D.'}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    </>
                )}

                {kategoria === 'B' && (
                    <>
                        <label className={"d-flex fw-bold mb-0 w-100"}>M.1 Analiza ryzyka</label>

                        <RyzykaKatBRepeater
                            wiz={props.wiz}
                            parentListName={'ryzyka_list'}
                        />
                    </>
                )}
            </div>
        </div>
    )
}

Ryzyka.propTypes = {
    wiz: PropTypes.any,
}
